import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { PickupService } from '../services/pickup.service';

export const pickupGuard: CanActivateFn = (route, state) => {
  const pickupService = inject(PickupService);
  const router = inject(Router);

  if (pickupService.getPickup())
    return true;

  router.navigate(['/'], {replaceUrl: true});
  return false;
};
